import ValidationMessageDialog from './ValidationMessageDialog.component';

export default ValidationMessageDialog;
